import React, { useEffect } from 'react';

// https://www.joshwcomeau.com/snippets/react-hooks/use-timeout/
export const useTimeout = (callback, delay) => {
  const timeoutRef = React.useRef<any>(null);
  const savedCallback = React.useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => savedCallback.current();

    if (typeof delay === 'number') {
      timeoutRef.current = window.setTimeout(tick, delay);
      return () => window.clearTimeout(timeoutRef.current);
    }

    return () => {};
  }, [delay]);

  return timeoutRef;
};

export interface Props {
  cb(): void;
  delay: number;
}

export const Timeout = ({ cb, delay }: Props) => {
  useTimeout(cb, delay);

  return null;
};
